module.exports = __webpack_public_path__ + "img/9791156330417.d7c68374.jpg";